export default "__VITE_ASSET__9mWVUkCr__"